<div *ngIf="planUsuario && planUsuario.pagado && !planUsuario.activo && type != 'extend' && type != 'change'; else planNoPagado" class="card border-width-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
	<div class="card-body">
		<h4 class="font-weight-bold text-3 mb-3">El plan ya se encuentra pagado</h4>
		<table class="shomt-3" style="width: 100%" *ngIf="planSeleccionado">
			<tbody>
				<tr>
					<td>
						<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planSeleccionado.nombre }}</strong>
						<span class="text-1">Costo Mensual</span>
					</td>
					<td class="align-top">
						<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planSeleccionado.precio | number : "1.0-2" : "es" }}</span>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Forma de Pago</strong>
					</td>
					<td>
						<strong><span class="amount font-weight-medium" id="textPlanes">Webpay</span></strong>
					</td>
				</tr>
				<tr>
					<td colspan="2">
						<hr />
					</td>
				</tr>
				<tr *ngIf="resumenCuenta?.proporcional > 0">
					<td>
						<strong class="text-color-dark">Proporcional ({{ resumenCuenta.differenceInDays }} días):</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textPlanes">{{ resumenCuenta.proporcional | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Planes:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textPlanes">{{ planUsuario.totalPlanes | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Certificaciones (P. único):</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textCertificaciones">{{ planUsuario.totalCertificacion | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td colspan="2"></td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Subtotal:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textSubtotal">{{ planUsuario.subTotal | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark" id="textDescuentoPorc">Descuento:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textDescuento">{{ planUsuario.descuento | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">Neto:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textNeto">{{ planUsuario.neto | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr>
					<td>
						<strong class="text-color-dark">IVA:</strong>
					</td>
					<td>
						<strong
							>$<span class="amount font-weight-medium" id="textIVA">{{ planUsuario.iva | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
				<tr class="total">
					<td>
						<strong class="text-color-dark">Total:</strong>
					</td>
					<td>
						<strong class="text-color-dark"
							>$<span class="amount text-color-dark text-5" id="textTotal">{{ planUsuario.total | number : "1.0-2" : "es" }}</span></strong
						>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<ng-template #planNoPagado>
	<div class="card border-width-3 border-radius-0 border-color-hover-dark" data-plugin-sticky data-plugin-options="{'minWidth': 991, 'containerSelector': '.row', 'padding': {'top': 85}}">
		<div class="card-body">
			<h4 class="font-weight-bold text-uppercase text-4 mb-3">RESUMEN</h4>

			<div class="loading-overlay loading-resumen" *ngIf="isLoading">
				<img src="./assets/deployAssets/icons/loader_16x16.gif" />
			</div>
			<table class="shomb-3" *ngIf="planSeleccionado">
				<tbody>
					<tr *ngIf="nmesesAntiguo > 0 || type != 'extend'">
						<td class="td_shop">
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planSeleccionado.nombre }}</strong>
							<span class="text-1">Costo Mensual</span>
						</td>
						<td class="align-top td_shop">
							<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planSeleccionado.precio | number : "1.0-2" : "es" }}</span>
						</td>
					</tr>
					<tr *ngIf="nmeses > nmesesCorte && nmesesNuevo > 0 && type == 'extend'">
						<td class="td_shop">
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Plan {{ planNuevo.nombre }} (Nuevo)</strong>
							<span class="text-1">Costo Mensual</span>
						</td>
						<td class="align-top td_shop">
							<span class="amount font-weight-medium text-color-grey" id="precioPlan">${{ planNuevo.precio | number : "1.0-2" : "es" }}</span>
						</td>
					</tr>

					<tr class="payment-methods">
						<td colspan="2" class="td_shop">
							<strong class="d-block text-color-dark mb-2" ngbTooltip="Proceso que se ejecuta una vez en la vida del contribuyente. Es el enrolamiento en el SII para emitir documentos">Certificación</strong>

							<div class="form-group row mx-auto" style="align-items: baseline">
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radio1" class="custom-control-input" name="certificacionPropia" [checked]="tipoCertificacion == 'propia'" value="propia" (change)="updateCertificacion($event.target.value)" />
									<label class="custom-control-label" for="radio1">Certificaré por mi cuenta / Estoy certificado</label>
								</div>
								<div *ngIf="isIndependiente && nmeses >= 12" class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radio2" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'incluida'" value="incluida" (change)="updateCertificacion($event.target.value)" />
									<label class="custom-control-label" for="radio2">Incluida con el plan</label>
								</div>
								<div *ngIf="!isIndependiente && nmeses >= 6" class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radio2" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'incluida'" value="incluida" (change)="updateCertificacion($event.target.value)" />
									<label class="custom-control-label" for="radio2">Incluida con el plan</label>
								</div>
								<div *ngIf="isIndependiente && nmeses < 12" class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radio3" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'agregar'" value="agregar" (change)="updateCertificacion($event.target.value)" />
									<label class="custom-control-label" for="radio3">Quiero agregar la certificación</label>
								</div>
								<div *ngIf="!isIndependiente && nmeses < 6" class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radio3" name="certificacionPropia" class="custom-control-input" [checked]="tipoCertificacion == 'agregar'" value="agregar" (change)="updateCertificacion($event.target.value)" />
									<label class="custom-control-label" for="radio3">Quiero agregar la certificación</label>
								</div>
							</div>
						</td>
					</tr>
					<tr id="groupCertificaciones" *ngIf="tipoCertificacion != 'propia'">
						<td colspan="2" class="td_shop">
							<div class="d-flex flex-column">
								<div *ngFor="let cert of certificaciones" class="d-flex align-items-center text-color-grey mb-0" style="justify-content: space-between">
									<label for="{{ cert.nombre }}"> <input id="{{ cert.nombre }}" type="checkbox" class="me-2" name="{{ cert.nombre }}" [checked]="cert.solicitada" (change)="updateModelCertificacion(cert)" /> {{ cert.nombre }} </label>
									<label id="valorFactElect">{{ cert.valor | number : "1.0-2" : "es" }}</label>
								</div>
							</div>
						</td>
					</tr>
					<tr class="payment-methods" *ngIf="compraCertificado?.comprar">
						<td colspan="2" class="td_shop">
						  <strong class="d-block text-color-dark mb-2">Certificado Digital</strong>
					  
						  <!-- duración -->
						  <div class="form-group d-flex align-items-center" style="justify-content: space-between">
							<div class="d-flex">
								<label class="mr-3 mb-0 mt-3">Duración:</label>
								<select class="form-control w-auto"
										[(ngModel)]="compraCertificado.duracion"
										(change)="onChangeDuracion()">
								<option [ngValue]="1">1 año</option>
								<option [ngValue]="2">2 años</option>
								<option [ngValue]="3">3 años</option>
								</select>
							</div>
							
							<div class="text-right">
								<button type="button"
									class="btn btn-link text-decoration-none text-1 font-weight-semibold text-color-danger p-0 ms-3"
									(click)="eliminarCertificadoDigital()">
									<i class="fas fa-trash-alt text-danger"></i>
								</button>
							</div>		
						
						  </div>
					  
							<div class="checkbox-list plan-price mb-4">
								<label style="margin-bottom: 3px; font-weight: 400;" class="checkbox">
								<input type="checkbox"
										id="chkGarantia"
										[(ngModel)]="compraCertificado.garantia"
										(change)="onCheckBoxGarantia()" />
								<span></span>Añadir Garantía de Recuperación
								</label>
								<label class="price-label">
									valor: {{ compraCertificado.precioGarantia | currency:'CLP':'symbol':'1.0-0':'es' }} + IVA
								</label>
							</div>
						</td>
					</tr>
					  

					<tr class="payment-methods">
						<td colspan="2" class="td_shop">
							<strong class="d-block text-color-dark mb-2">Formas de Pago</strong>
							<div class="form-group row mx-auto" style="align-items: baseline">
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radiowebpay" class="custom-control-input" name="formaPago" value="webpay" [checked]="formaPago == 'webpay' || type == 'paymentBlocked'" (change)="updateFormaPago($event.target.value)" />
									<label class="custom-control-label" for="radiowebpay">WebPay</label>
								</div>
								<div class="custom-control custom-radio custom-control-inline">
									<input type="radio" id="radiofree" name="formaPago" class="custom-control-input" value="free" [disabled]="type == 'extend' || type == 'change'" [checked]="formaPago == 'free'" (change)="updateFormaPago($event.target.value)" />
									<label class="custom-control-label" for="radiofree">Usaré los 7 dias gratuitos</label>
								</div>
							</div>
						</td>
					</tr>
					<tr class="payment-methods">
						<td colspan="2" class="td_shop">
							<strong class="d-block text-color-dark mb-2">Adicionales</strong>
							<div class="form-group row mx-auto" style="align-items: baseline">
								<div class="checkbox-list plan-price">
									<label style="margin-bottom: 3px" class="checkbox" [ngClass]="{ 'checkbox-disabled': adicionalSinMensajePDF.readOnly }" ngbTooltip="{{ adicionalSinMensajePDF.descripcion }}">
										<input type="checkbox" name="Checkboxes1" id="checkboxMensaje" [(ngModel)]="adicionalSinMensajePDF.checked" [disabled]="adicionalSinMensajePDF.readOnly" (change)="actualizarCalculos()" />
										<span></span>Sin mensaje de SimpleFactura en PDF</label
									><label class="price-label">{{ adicionalSinMensajePDF.message }}</label>
									<label style="margin-bottom: 4px; margin-top: 10px" class="checkbox" [ngClass]="{ 'checkbox-disabled': adicionalAccesoDTERecibido.readOnly }" ngbTooltip="{{ adicionalAccesoDTERecibido.descripcion }}">
										<input type="checkbox" checked="checked" id="checkboxRecibidos" name="Checkboxes1" [(ngModel)]="adicionalAccesoDTERecibido.checked" [disabled]="adicionalAccesoDTERecibido.readOnly" (change)="actualizarCalculos()" />
										<span></span>Acceso a DTEs Recibidos</label
									>
									<label class="price-label">{{ adicionalAccesoDTERecibido.message }}</label>
								</div>
							</div>
						</td>
					</tr>
					<tr>
						<td style="vertical-align: top">
							<strong class="text-color-dark">Cupón Promocional</strong>
						</td>
						<td>
							<div style="display: inline-block; vertical-align: top">
								<input #inputCodigoDescuento type="text" (blur)="updateCupon(inputCodigoDescuento.value)" style="border: 1px solid #e4e6ef; border-radius: 0.42rem; width: 100%" />
							</div>
							<div *ngIf="cupon" style="display: inline-block">
								<i *ngIf="cupon.activo"
									><small>${{ cupon.descuento | number : "1.0-2" : "es" }}</small></i
								>
							</div>
							<div *ngIf="!cupon && inputCodigoDescuento.value.length > 0" style="display: inline-block">
								<i
									><small>{{ mensajeCupon }}</small></i
								>
							</div>
						</td>
					</tr>
					<tr>
						<td colspan="2" class="text-start align-top td_shop">
							<strong class="text-color-dark">Tiempo de contratación</strong>
							<p class="mb-1" id="textMeses">Meses: {{ nmeses }}</p>
							<input
							type="range"
							[min]="resumenCuenta.mesesAbono || 1"
							max="24"
							[value]="nmeses"
							(change)="updateMes($event.target.value)"
							class="custom-range mb-3"
							/>					
						</td>
					</tr>
					<tr *ngIf="type == 'wizard'" style="margin-bottom: 5px">
						<td>
							<div class="text-color-dark">Fecha de Término:</div>
						</td>
						<td>
							<div>
								<span class="amount font-weight-medium" id="fechaPlanes">{{ resumenCuenta.fechaTermino | date : "dd/MM/yyyy" }}</span>
							</div>
						</td>
					</tr>
					<tr *ngIf="resumenCuenta?.proporcional > 0">
						<td>
							<strong class="text-color-dark">Proporcional ({{ resumenCuenta?.differenceInDays }} días):</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textPlanes">{{ resumenCuenta.proporcional | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">Planes:</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textPlanes">{{ resumenCuenta.totalPlanes | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">Adicionales:</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textAdicionales">{{ resumenCuenta.totalAdicionales | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">Certificaciones (P. único):</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textCertificaciones">{{ resumenCuenta.totalCertificaciones | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr *ngIf="compraCertificado?.comprar">
						<td>
							<strong class="text-color-dark">Certificado Digital (P. único):</strong>
						</td>
						<td>
							<strong>$<span class="amount font-weight-medium" id="textCertificado">{{ compraCertificado.total | number : "1.0-0" : "es" }}</span></strong>
						</td>
					</tr>

					<tr>
						<td colspan="2"></td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">Subtotal:</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textSubtotal">{{ resumenCuenta.subtotal | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark" id="textDescuentoPorc">Descuento ({{ resumenCuenta.descuentoPorc }}%):</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textDescuento">{{ resumenCuenta.descuento | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr *ngIf="resumenCuenta.abono">
						<td>
							<strong class="text-color-dark">
								Abono:
							</strong>
						</td>
						<td>
							<strong>
								$<span class="amount font-weight-medium">{{ resumenCuenta.abono | number:'1.0-0':'es' }}</span>
							</strong>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">Neto:</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textNeto">{{ resumenCuenta.neto | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr>
						<td>
							<strong class="text-color-dark">IVA:</strong>
						</td>
						<td>
							<strong
								>$<span class="amount font-weight-medium" id="textIVA">{{ resumenCuenta.iva | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
					<tr class="total">
						<td>
							<strong class="text-color-dark">Total:</strong>
						</td>
						<td>
							<strong class="text-color-dark"
								>$<span class="amount text-color-dark text-5" id="textTotal">{{ resumenCuenta.total | number : "1.0-2" : "es" }}</span></strong
							>
						</td>
					</tr>
				</tbody>
			</table>
			<table class="shomb-3" *ngIf="!planSeleccionado">
				<tbody>
					<tr>
						<td class="td_shop">
							<strong class="d-block text-color-dark line-height-1 font-weight-semibold" id="nombrePlan">Debe seleccionar un plan para continuar</strong>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</ng-template>
